import React, { forwardRef } from 'react';
import { Device } from './Device';

export const Speaker = forwardRef((props: any, ref) => (
  <Device {...props} ref={ref} model="speaker" />
));
